import SmallLoader from "../../Common/SmallLoader";
import cloud from "../../../assets/images/cloud.svg";
import HelperService from "../../../Services/HelperService";
import { Button, Col, Form } from "react-bootstrap";
import { DocumentDetailsInterface } from "../../../assets/interface/primeSharkWebsite_interface";
import DocumentNameDisplay from "./DocumentNameDisplay";
import {
  DOCUMENT_TYPE,
  excludedDocKeys,
} from "../../../assets/constants/constants";
import { isNotEmittedStatement } from "typescript";
import CommonModal from "../../Common/CommonModal";
import { useState } from "react";
interface PropsData {
  fileLoaders: any;
  uploadFile: any;
  type: string;
  documentList?: DocumentDetailsInterface[];
  document?: DocumentDetailsInterface | null;
  accept?: string;
  infoCall: () => void;
}
const UploadDocument = ({
  fileLoaders,
  uploadFile,
  type,
  documentList,
  document,
  accept,
  infoCall,
}: PropsData) => {
  return (
    <div className="mb-3" key={type}>
      {/* <label>
        {type &&
          excludedDocKeys.includes(type) &&
          type !== DOCUMENT_TYPE.PRODUCT_DEMO &&
          HelperService.removeUnderScore(type)}
      </label> */}
      <div className="position-relative border-dashed">
        <div className="top35 text-center position-absolute">
          {" "}
          {fileLoaders[type] ? (
            <SmallLoader />
          ) : (
            <>
              <div className="d-flex justify-content-center align-items-center gap-2 cursor-pointer">
                <img src={cloud} alt="Cloud" />
                <label
                  htmlFor={`browse-${type}`}
                  className="upload-document ms-1 mb-0 pb-0"
                  style={{ color: "#66C15E" }}
                >
                  Upload Document
                </label>
              </div>
              {type === DOCUMENT_TYPE.BUSINESS_PHOTO ? (
                <span
                  className="text-warning d-block mt-1"
                  style={{ fontSize: "10px" }}
                >
                  Upload a photo clearly showing your registered business name
                  (e.g., office signage, trade license, or branded materials).
                </span>
              ) : (
                <span
                  className="text-muted d-block mt-1"
                  style={{ fontSize: "10px" }}
                >
                  Document page count must not be greater than 15 pages.
                </span>
              )}
            </>
          )}
        </div>
        <Form.Control
          type="file"
          className=" opacity-0"
          name={type}
          onChange={uploadFile}
          accept={accept || undefined}
          id={`browse-${type}`}
        />
      </div>
      <div className="mt-2">
        {document ? (
          <DocumentNameDisplay
            document={document}
            infoCall={() => {
              infoCall();
            }}
          />
        ) : (
          documentList &&
          documentList.length > 0 &&
          documentList.map(
            (item: DocumentDetailsInterface, indeX: number) =>
              !excludedDocKeys.includes(item?.type) && (
                // <Col lg={12} sm={12} key={indeX} className="mb-3 d-flex justify-content-between">
                //   <label className="documents">
                //     {item?.title ? `${HelperService.ProperCase(item?.title)} uploaded` : "  "}
                //   </label>
                //   <div className="d-flex align-items-center gap-2 pt-2">
                //     <Button
                //       variant=""
                //       size="sm"
                //       onClick={() => handleView(item.file_name, item?.file_title, item?.title)}
                //     >
                //       View
                //     </Button>
                //   </div>
                // </Col>
                <DocumentNameDisplay
                  document={item}
                  infoCall={() => {
                    infoCall();
                  }}
                />
              ),
          )
        )}
        {/* {document?.type &&(document || (documentList&& documentList?.length>0))  ? <DocumentNameDisplay document={document} /> : null} */}
      </div>
    </div>
  );
};
export default UploadDocument;
